import _Search from './Search';

import './style/index.js';

export * from './type';

export const Search = _Search;

export default Search;
